import { render, staticRenderFns } from "./RepairKitLabel.vue?vue&type=template&id=96ef6354&scoped=true"
import script from "./RepairKitLabel.vue?vue&type=script&lang=js"
export * from "./RepairKitLabel.vue?vue&type=script&lang=js"
import style0 from "./RepairKitLabel.vue?vue&type=style&index=0&id=96ef6354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ef6354",
  null
  
)

export default component.exports